<ng-container [ngSwitch]="type">
    <!-- Postponed: Cancel Postpone + Create + Read -->
    <ng-container *ngSwitchCase="'postponed'">
        <button class="action-button cancel-postpone" (click)="onCancelPostpone($event)"
            [attr.aria-label]="'notifications.postpone.cancel' | translate"
            [title]="'notifications.postpone.cancel' | translate">
            <svg class="action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor"/>
                <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </button>

        <button class="action-button create-task" (click)="onCreateTask($event)"
            [attr.aria-label]="'myTasks.create_task.title' | translate"
            [title]="'myTasks.create_task.title' | translate">
            <svg class="action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
                <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>

        <button *ngIf="showMarkReadButton" class="action-button mark-read" (click)="onMarkAsRead($event)"
            [attr.aria-label]="'notifications.markAsRead' | translate" [title]="'notifications.markAsRead' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>

        <button *ngIf="showMarkUnreadButton" class="action-button mark-unread" (click)="onMarkAsUnread($event)"
            [attr.aria-label]="'notifications.markAsUnread' | translate" [title]="'notifications.markAsUnread' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="18" cy="6" r="3" fill="currentColor"/>
            </svg>
        </button>
    </ng-container>

    <!-- Pinned: Pin + Create + Read only -->
    <ng-container *ngSwitchCase="'pinned'">
        <button class="action-button pin pinned" (click)="onTogglePin($event)"
            [attr.aria-label]="'notifications.unpin' | translate" [title]="'notifications.unpin' | translate">
            <svg class="pin-icon rotated" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M16 12V4H17V2H7V4H8V12L6 14V16H11.2V22H12.8V16H18V14L16 12Z" />
            </svg>
        </button>

        <button class="action-button create-task" (click)="onCreateTask($event)"
            [attr.aria-label]="'myTasks.create_task.title' | translate"
            [title]="'myTasks.create_task.title' | translate">
            <svg class="action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
                <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>

        <button *ngIf="showMarkReadButton" class="action-button mark-read" (click)="onMarkAsRead($event)"
            [attr.aria-label]="'notifications.markAsRead' | translate" [title]="'notifications.markAsRead' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>

        <button *ngIf="showMarkUnreadButton" class="action-button mark-unread" (click)="onMarkAsUnread($event)"
            [attr.aria-label]="'notifications.markAsUnread' | translate" [title]="'notifications.markAsUnread' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="18" cy="6" r="3" fill="currentColor"/>
            </svg>
        </button>
    </ng-container>

    <!-- Active: Postpone + Create + Pin + Read -->
    <ng-container *ngSwitchCase="'active'">
        <button *ngIf="showPostponeButton" class="action-button postpone" (click)="onPostponeClick($event)"
            [attr.aria-label]="'notifications.postpone.tooltip' | translate"
            [title]="'notifications.postpone.tooltip' | translate">
            <svg class="action-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
            </svg>

            <!-- Postpone submenu -->
            <div class="postpone-submenu" *ngIf="showPostponeMenu">
                <button type="button" class="postpone-option" (click)="onPostpone(1)">
                    {{ 'notifications.postpone.oneDay' | translate }}
                </button>
                <button type="button" class="postpone-option" (click)="onPostpone(3)">
                    {{ 'notifications.postpone.threeDays' | translate }}
                </button>
                <button type="button" class="postpone-option" (click)="onPostpone(5)">
                    {{ 'notifications.postpone.fiveDays' | translate }}
                </button>
            </div>
        </button>

        <button class="action-button create-task" (click)="onCreateTask($event)"
            [attr.aria-label]="'myTasks.create_task.title' | translate"
            [title]="'myTasks.create_task.title' | translate">
            <svg class="action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
                <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>

        <button class="action-button pin" [class.pinned]="isPinned" (click)="onTogglePin($event)"
            [attr.aria-label]="(isPinned ? 'notifications.unpin' : 'notifications.pin') | translate"
            [title]="(isPinned ? 'notifications.unpin' : 'notifications.pin') | translate">
            <svg class="pin-icon" [class.rotated]="isPinned" width="20" height="20" viewBox="0 0 24 24"
                fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M16 12V4H17V2H7V4H8V12L6 14V16H11.2V22H12.8V16H18V14L16 12Z" />
            </svg>
        </button>

        <button *ngIf="showMarkReadButton" class="action-button mark-read" (click)="onMarkAsRead($event)"
            [attr.aria-label]="'notifications.markAsRead' | translate" [title]="'notifications.markAsRead' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>

        <button *ngIf="showMarkUnreadButton" class="action-button mark-unread" (click)="onMarkAsUnread($event)"
            [attr.aria-label]="'notifications.markAsUnread' | translate" [title]="'notifications.markAsUnread' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="18" cy="6" r="3" fill="currentColor"/>
            </svg>
        </button>
    </ng-container>

    <!-- Other: Postpone + Pin + Create + Read -->
    <ng-container *ngSwitchDefault>
        <button *ngIf="showPostponeButton" class="action-button postpone" (click)="onPostponeClick($event)"
            [attr.aria-label]="'notifications.postpone.tooltip' | translate"
            [title]="'notifications.postpone.tooltip' | translate">
            <svg class="action-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
            </svg>

            <!-- Postpone submenu -->
            <div class="postpone-submenu" *ngIf="showPostponeMenu">
                <button type="button" class="postpone-option" (click)="onPostpone(1)">
                    {{ 'notifications.postpone.oneDay' | translate }}
                </button>
                <button type="button" class="postpone-option" (click)="onPostpone(3)">
                    {{ 'notifications.postpone.threeDays' | translate }}
                </button>
                <button type="button" class="postpone-option" (click)="onPostpone(5)">
                    {{ 'notifications.postpone.fiveDays' | translate }}
                </button>
            </div>
        </button>

        <button class="action-button pin" [class.pinned]="isPinned" (click)="onTogglePin($event)"
            [attr.aria-label]="'notifications.pin' | translate" [title]="'notifications.pin' | translate">
            <svg class="pin-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M16 12V4H17V2H7V4H8V12L6 14V16H11.2V22H12.8V16H18V14L16 12Z" />
            </svg>
        </button>

        <button class="action-button create-task" (click)="onCreateTask($event)"
            [attr.aria-label]="'myTasks.create_task.title' | translate"
            [title]="'myTasks.create_task.title' | translate">
            <svg class="action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
                <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>

        <button *ngIf="showMarkReadButton" class="action-button mark-read" (click)="onMarkAsRead($event)"
            [attr.aria-label]="'notifications.markAsRead' | translate" [title]="'notifications.markAsRead' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>

        <button *ngIf="showMarkUnreadButton" class="action-button mark-unread" (click)="onMarkAsUnread($event)"
            [attr.aria-label]="'notifications.markAsUnread' | translate" [title]="'notifications.markAsUnread' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="18" cy="6" r="3" fill="currentColor"/>
            </svg>
        </button>
    </ng-container>
</ng-container>